const style = document.createElement('style');
style.innerHTML = `
.container {
    height: 200vh;
    min-height: 100vh;
    display: flex;
    flex-flow: row;
    margin: 0 auto;
    justify-content: center;
}

.container:before {
    content: "";
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 125vmax;
    height: 125vmax;
    border-radius: 100%;
    background-image: linear-gradient(to top, #fbc2eb 0%, #a6c1ee 100%);
    box-shadow: 0 0 20px pink;
    transition: all 500ms cubic-bezier(0.49, 0.23, 0, 0.99);
    opacity: 0;
}

.completed:before {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
}

svg {
    position: sticky;
    transform: rotate(-90deg);
}

svg circle {
    stroke: rgba(0, 0, 0, 0.1);
    stroke-width: 10px;
    stroke-linecap: round;
    fill: transparent;
}

svg .progress-bar {
    stroke: url(#grad);
    transition: stroke-dashoffset 0 ease-in-out;
    filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.2));
}

.pct {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums;
}
`;

const pct = document.createElement("p");
pct.classList.add("pct");
pct.innerHTML = "0%";

const stop1 = buildElement("stop", {
    offset: "0%",
    "stop-color": "#fbc2eb"
});

const stop2 = buildElement("stop", {
    offset: "100%",
    "stop-color": "#a6c1ee"
});

const linearGradient = buildElement("linearGradient", {
    id: "grad"
});
linearGradient.appendChild(stop1);
linearGradient.appendChild(stop2);

const defs = buildElement("defs");
defs.appendChild(linearGradient);

const circle1 = buildElement("circle", {
    cx: 100,
    cy: 100,
    r: 80
});

const progressBar = buildElement("circle", {
    class: "progress-bar",
    cx: 100,
    cy: 100,
    r: 80
});

const svg = buildElement("svg", {
    class: "complete",
    width: 200,
    height: 200,
    viewport: "0 0 100 100"
});
svg.appendChild(defs);
svg.appendChild(circle1);
svg.appendChild(progressBar);

const container = document.createElement("div");
container.classList.add("container");
container.appendChild(pct);
container.appendChild(svg);

function buildElement(tag, attrs) {
    const element = document.createElementNS("http://www.w3.org/2000/svg", tag);

    for (let name in attrs) {
        element.setAttribute(name, attrs[name]);
    }

    return element;
}


class AripdProgress extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(style);
        this.shadowRoot.appendChild(container);
    }

    connectedCallback() {
        window.onload = () => {
            const totalLength = progressBar.getTotalLength();

            this.setTopValue(svg);

            progressBar.style.strokeDasharray = totalLength;
            progressBar.style.strokeDashoffset = totalLength;

            window.addEventListener('scroll', () => {
                this.setProgress(container, pct, progressBar, totalLength);
            });

            window.addEventListener('resize', () => {
                this.setTopValue(svg);
            });
        };
    }

    adoptedCallback() {
    }

    disconnectedCallback() {
    }

    setTopValue(svg) {
        svg.style.top = document.documentElement.clientHeight * 0.5 - (svg.getBoundingClientRect().height * 0.5) + 'px';
    }


    setProgress(container, pct, progressBar, totalLength) {
        const clientHeight = document.documentElement.clientHeight;
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = document.documentElement.scrollTop;

        const percentage = scrollTop / (scrollHeight - clientHeight);
        if (percentage === 1) {
            container.classList.add('completed');
        } else {
            container.classList.remove('completed');
        }
        pct.innerHTML = Math.round(percentage * 100) + '%';
        progressBar.style.strokeDashoffset = totalLength - totalLength * percentage;
    }

}

customElements.define('aripd-progress', AripdProgress);